import React from "react";
import { Grid, Box, Typography, Paper } from "@mui/material";
import useAxios from '../../Hooks/useAxios';
import RMCActiveProcess from "../../Components/RMCActiveProcess/RMCActiveProcess";
import RMCCriticalPoint from "../../Components/RMCCriticalPoint/RMCCriticalPoint";
import RMCDurationAverage from "../../Components/RMCDurationAverage/RMCDurationAverage";

/**
 * Component for displaying the top metric cards in the Reports view.
 * Currently in placeholder state.
 * * @component
 */



//Checking empty filterValue
function CheckEmptyValue(strDept)
{
    if (!strDept || strDept.trim() === "") {
        console.log("strDept empty");
         return true;
    }
    else
        return false;
}


// Filtering data array by strDept. Returns array or null
const GetFilteredData = (data, strDept) => {
  if (data && Array.isArray(data)) {

        // when filter value is empty
        if (CheckEmptyValue(strDept) === true) {
           return data;
        };

        // Returning an array with filtered objects by center
        const resultCenterData = data.filter(obj => String(obj.responsibleCenter).toLowerCase() === strDept);
        if (resultCenterData.length != 0) {
           //console.log("resultCenterData.length:", resultCenterData.length)
           return resultCenterData;
        }
        // In case of no items, return array filtered by department
        else
        {
        const resultDeptData = data.filter(obj => String(obj.department).toLowerCase() === strDept);
            //console.log("resultDeptData.length:", resultDeptData.length)
            return resultDeptData;
        }

   }
   console.log("ERROR -- data is null");
   return null;
}

 const ReportsMetricCards = ({ strDepartment, data }) => {
    //console.log("************* strDepartment: ", strDepartment)
    let dataResult = GetFilteredData(data, strDepartment);


   return (
     <Paper
       elevation={0}
       sx={{
         p: 4,
         border: '1px dashed #ccc',
         display: 'flex',
         justifyContent: 'center',
         alignItems: 'center',
         bgcolor: '#f9f9f9',
         borderRadius: 2
       }}
     >

       <Grid container spacing={2}>
               <Grid item xs={12} sm={4}>
                 <RMCActiveProcess
                 data = {dataResult}
                  />
               </Grid>
               <Grid item xs={12} sm={4}>
                 <RMCDurationAverage
                 data = {dataResult}
                 />
               </Grid>
               <Grid item xs={12} sm={4}>
                 <RMCCriticalPoint
                 strDepartment = {strDepartment}
                 data = {dataResult}
                 />
               </Grid>
             </Grid>


     </Paper>
   );
 };

export default ReportsMetricCards;